
//export const API_BASE_URL = 'https://pamarket.hankuper.com:33666/api';
export const API_BASE_URL = '/api';
export const API_UPLOAD_URL = '/zuul/api';
export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const BASE_URL = '/';


export const POLL_LIST_SIZE = 30;
export const MAX_CHOICES = 6;
export const POLL_QUESTION_MAX_LENGTH = 140;
export const POLL_CHOICE_MAX_LENGTH = 40;

export const NAME_MIN_LENGTH = 4;
export const NAME_MAX_LENGTH = 40;

export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 40;

export const EMAIL_MAX_LENGTH = 40;

export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 20;

// pagination settings
export const PAGINATION_LIST_SIZE = 3;
export const PAGINATION_DEFAULT_LIMIT = 100;

//user status
export const BLOCKED = 'BLOCKED';
export const NOT_APPROVED = 'NOT_APPROVED';
export const ACTIVE = 'ACTIVE';

// authority roles
export const GUEST = 'GUEST';
export const SUPER_ADMIN = 'SUPER_ADMIN';
export const COMPANY_ADMIN = 'COMPANY_ADMIN';
export const USER = 'USER';
export const DEVELOPER = 'DEVELOPER';

export const USER_ROLES = {
	'SUPER_ADMIN': 'Super admin',
	'COMPANY_ADMIN': 'Admin',
	'USER': 'User',
	'GUEST':  'Guest'
};

// company types
export const RETAIL = 'RETAIL';
export const DEV = 'DEVELOP';
export const OPERATOR = 'OPERATOR';
export const COMPANY_TYPES = {
	'RETAIL': 'Retail',
	'DEV': 'Developer',
	'OPERATOR': 'Operator',
};

// members list modal views
export const MEMBERSMODALVIEWS = {
	ADD: 'add',
	REMOVE: 'remove'
};

// companies list modal views
export const COMPANIESMODALVIEWS = {
	ADD: 'ADD',
	REMOVE: 'REMOVE',
	VIEW: 'VIEW'
};

// store modal views
export const STOREMODALVIEWS = {
	EDIT: 'edit',
	NEW: 'new'
};

// market modal views
export const MARKETVIEW = {
	COMPANY_MARKET: 'COMPANY_MARKET',
	GLOBAL_MARKET: 'GLOBAL_MARKET'
};

// local market

export const VIEWS = {
	POCKET: 'POCKET',
	ALL: 'ALL',
	NONPOCKET: 'NONPOCKET',
	PACKAGE_AND_APP: 'PACKAGE_AND_APP',
	PACKAGE_ONLY: 'PACKAGE_ONLY',
	APP_ONLY: 'APP_ONLY',
	UPDATES_ONLY: 'UPDATES_ONLY',
	PROMO: 'PROMO'
};

// notifications types
export const NOTIFICATION_TYPES = {
	NEW: 'NEW',
	ACCEPTED: 'ACCEPTED',
	DECLINED: 'DECLINED',
	UPDATED: 'UPDATED',
	OUTDATED: 'OUTDATED'
};

// calls types
export const CALLS_TYPES = {
	NEW: 'NEW',
	ACCEPTED: 'ACCEPTED',
	DECLINED: 'DECLINED',
	CANCELED: 'CANCELED',
	STOPPED: 'STOPPED',
	FINISHED: 'FINISHED'
};

//offer types
export const OFFER_TYPES = {
	ACTIVE: 'ACTIVE',
	DRAFT: 'DRAFT',
	STOPPED: 'STOPPED',
	CANCELED: 'CANCELED',
	FINISHED: 'FINISHED'
}



// WEBPACK FOOTER //
// ./src/helpers/constants.js